import PermitSharePage from "./permitShare";

export default PermitSharePage;